import axios from '@axios'

const group = 'salary_and_commission/'
const route = 'pay_professional'

export default {
  namespaced: true,
  state: {
    dialogPayProgress: '25',
    dialogPay: '', // TypePayment,PaymentSummary,CheckPayment,PaymentCompleted
    dataPayment: {
      type_payment: null, // ex: [salary, commission]
      employee: null, // ex: [1, 2, 3]
      period: null, // ex: 2026-01-01 - 2026-01-31
      note: null, // ex: 'Pagamento de salario e comissão'
      status: null, // ex: [pending, approved, rejected]
      method_payment: 'Dinheiro', // ex: [Dinheiro, Transferência, Pix]
    },
    period: null,
  },
  getters: {
    getDialogPayProgress(state) {
      return state.dialogPayProgress
    },
    getDialogPay(state) {
      return state.dialogPay
    },
    getPeriod(state) {
      return state.dataPayment.period
    },
    getNote(state) {
      return state.dataPayment.note
    },
    getMethodPayment(state) {
      return state.dataPayment.method_payment
    },
    getConfigTypePayment(state) {
      return state.dataPayment.type_payment
    },
  },

  mutations: {
    setDialogPayProgress(state, dialog) {
      state.dialogPayProgress = dialog
    },
    setDialogPay(state, dialog) {
      state.dialogPay = dialog

      switch (dialog) {
        case 'TypePayment':
          state.dialogPayProgress = 25
          break
        case 'PaymentSummary':
          state.dialogPayProgress = 50
          break
        case 'CheckPayment':
          state.dialogPayProgress = 75
          break
        case 'PaymentCompleted':
          state.dialogPayProgress = 100
          break
      }
    },

    // clearPayment
    clearDataPayment(state) {
      state.dataPayment = {
        type_payment: [], // ex: [salary, commission]
        employee: [], // ex: [1, 2, 3]
        period: {}, // ex: 2026-01-01 - 2026-01-31
        note: '', // ex: 'Pagamento de salario e comissão'
        status: 'revision', // ex: [pending, approved, rejected]
        method_payment: 'Dinheiro', // ex: [Dinheiro, Transferência, Pix]
      }
    },

    // define os tipos de pagamnetos q sera pagos
    setConfigTypePayment(state, typePayments) {
      state.dataPayment.type_payment = typePayments
    },

    // define o funcionarios q serão pagos
    setConfigEmployee(state, employees) {
      state.dataPayment.employee = employees
    },

    setConfigPeriod(state, period) {
      state.dataPayment.period = period
    },
    setConfigStatus(state, status) {
      state.dataPayment.status = status
    },
    setPeriod(state, period) {
      state.dataPayment.period = period
    },
    setNote(state, note) {
      state.dataPayment.note = note
    },
    setMethodPayment(state, method_payment) {
      state.dataPayment.method_payment = method_payment
    },

  },
  actions: {
    // pagamento do funcionarios
    index(context, period) {
      return axios.post(group + route, period)
    },

    // resumo do ciclo de pagamento
    paymentSummary(context, payload) {
      return axios.post(`${group + route}/summary`, payload)
    },

    // Revisao de pagamento
    checkPayment(context) {
      const data = context.state.dataPayment

      return axios.post(`${group + route}/check_payment`, data)
    },

    // Faz o pagamento
    storePayment(context, data) {
      const { dataPayment } = context.state

      return axios.post(`${group + route}/store_payment`, dataPayment, data)
    },
    getDetailsPayment(context, { employee, period }) {
      return axios.post(`${group + route}/details_payment/${employee.id}`, period)
    },
    saveAdjustment(context, payload) {
      return axios.post(`${group + route}/save_adjustment`, payload)
    },

  },

}
